import {
    GET_CMS_MAIN_MENU,
    GET_CMS_MAIN_MENU_ERROR
} from "./types";
import CMSService from "../../services/cms.service";

export function getMainMenu() {
    return function (dispatch) {
        try {           
            return CMSService.reqMainMenu()
                .then((data) => {                                       
                    dispatch(
                        {
                            type: GET_CMS_MAIN_MENU,
                            payload: data
                        })
                });
        }
        catch (error) {
            return (dispatch) => {
                dispatch({
                    type: GET_CMS_MAIN_MENU_ERROR,
                });
            }
        }
    };
}